export const getLabelPlaceholderDefault = ({
    label = "",
    placeholder = "",
    contentType = "",
    isLabelHidden = false,
}) => {
    if (label === "" || isLabelHidden) {
        switch (contentType) {
            case "placeholder": {
                if (placeholder && placeholder !== "") return placeholder;
                break;
            }
        }
        return "Untitled field";
    } else {
        return label ? label : "Untitled field";
    }
};
